import { render, staticRenderFns } from "./ProjectsTicketsList.vue?vue&type=template&id=778e3fa5&"
import script from "./ProjectsTicketsList.vue?vue&type=script&lang=js&"
export * from "./ProjectsTicketsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VAlert,VCol,VContainer,VPagination,VProgressLinear,VRow,VWindowItem})
